<template>
    <div class="sticky top-0 flex justify-between px-6 h-14 items-center border-b-[1px] bg-white">
        <div class="flex gap-6">
            <div class="cursor-pointer" @click="store.state.minimized = !store.state.minimized">
                <img src="@/assets/icons/twotone/menu-1.svg" class="w-6 h-6">
            </div>
            <!-- <div class="cursor-pointer">
                <img src="@/assets/icons/twotone/search-normal-1.svg" class="w-6 h-6">
            </div> -->
        </div>
        <div class="flex gap-6">
            <div class="cursor-pointer">
                <img src="@/assets/icons/twotone/notification.svg" class="w-6 h-6">
            </div>
            <div class="cursor-pointer">
                <img src="@/assets/icons/twotone/info-circle.svg" class="w-6 h-6">
            </div>
            <!-- <div class="cursor-pointer">
                <img src="@/assets/icons/twotone/user.svg" class="w-6 h-6">
            </div> -->
            <Menu as="div" class="relative">
                <MenuButton class="cursor-pointer">
                    <img src="@/assets/icons/twotone/user.svg" class="w-6 h-6">
                </MenuButton>

                <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                    <MenuItems
                        class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div class="py-1">
                            <MenuItem v-slot="{ active }">
                            <button @click="logout"
                                :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">
                                Logout
                            </button>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </transition>
            </Menu>
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
const store = useStore()

const logout = async () => {
    await store.dispatch('auth/logout')
}
</script>